import { capitalizeTitle } from "./Strings"

const modelNames = [
    "AISBL",
    "ASBL",
    "Aandelen en andere effecten",
    "Abandon habitations/bâtiments et sites d'activité économique",
    "Actes de constitution et statuts",
    "Actions et autres titres",
    "Administratief recht",
    "Administratief statuut",
    "Afschriften, uitgiften, grossen, ...",
    "Alimentatie-verordening",
    "Aménagement du territoire",
    "Aménagement du territoire et urbanisme",
    "Andere bijzondere overeenkomsten",
    "Andere formules",
    "Andere kredieten",
    "Appartementsmede-eigendom",
    "Assainissement du sol",
    "Associations et fondations",
    "Autres contrats particuliers",
    "Autres crédits",
    "Autres formules",
    "BTW",
    "Bedingen van aanwas",
    "Bepaalde verkopingen van onroerende goederen",
    "Beslag onder derden",
    "Betalingsbevel-verordening",
    "Bewarend beslag op onroerend goed",
    "Bijzondere overeenkomsten",
    "Bodemsanering",
    "Boedelbeschrijving",
    "Bois",
    "Bos",
    "Brussel",
    "Brussel I-verordening",
    "Brussel IIbis-verordening",
    "Brussel Ibis-verordening",
    "Brussels Hoofdstedelijk Gewest",
    "Brusselse Huisvestingscode",
    "Bruxelles",
    "Certaines ventes d'immeubles",
    "Certification conforme de pièces sous seing privé",
    "Certification des signatures",
    "Citerne à gaz et à mazout",
    "Clauses dans l'acte",
    "Clauses diverses",
    "Clauses d'accroissement",
    "Clauses statutaires",
    "Clausules in de akte",
    "Code bruxellois du logement",
    "Code de Droit Economique",
    "Code de droit international privé",
    "Cohabitation",
    "Collectieve schuldenregeling",
    "Conservation de la nature",
    "Contrats particuliers",
    "Copies",
    "Copies, expéditions, grosses, etc.",
    "Copropriété ordinaire",
    "Copropriété par appartements",
    "Création d'entreprise",
    "Crédit hypothécaire",
    "DIP",
    "DIP et droit européen",
    "DIP européen",
    "Dading",
    "De bindende derdenbeslissing",
    "De gerechtelijke vereffening-verdeling",
    "De rangregeling",
    "De verkoop ingevolge uitvoerend beslag op onroerend goed",
    "Dispositions transitoires",
    "Dissolution et liquidation",
    "Diverse clausules",
    "Diversen",
    "Divorce par consentement mutuel",
    "Donation",
    "Droit Economique",
    "Droit Financier",
    "Droit Financier et Droit Economique",
    "Droit administratif",
    "Droit d'occupation et d'habitation",
    "Droit d'écriture",
    "Droit de préemption",
    "Droit de superficie",
    "Droit des entreprises",
    "Droit des entreprises et des sociétés",
    "Droit des personnes et droit (patrimonial) de la famille",
    "Droit des régimes matrimoniaux",
    "Droit fiscal",
    "Droit immobilier",
    "Droit judiciaire",
    "Droit notarial",
    "Droit successoral",
    "Droits d'enregistrement",
    "Droits de préemption",
    "Droits de succession",
    "Déclarations finales",
    "Echtscheiding door onderlinge toestemming",
    "Economisch recht",
    "Eensluidend verklaring onderhandse stukken",
    "Elektriciteit",
    "Emphytéose",
    "Emprunt et ouverture de crédit",
    "Energie",
    "Energie / EPB-certificatie",
    "Environnement / Sols",
    "Erfdienstbaarheden",
    "Erfopvolging-verordening",
    "Erfpacht",
    "Erfrecht",
    "Europees IPR",
    "Europese Executoriale Titel-verordening",
    "Expropriation",
    "Expéditions",
    "Extraits",
    "Federaal",
    "Financieel en Economisch recht",
    "Financieel recht",
    "Fiscaal recht",
    "Flandre",
    "Fondations",
    "Fonds de commerce",
    "Formules de comparution",
    "Fédéral",
    "Gas- en stookolietank",
    "Gemeentewegen",
    "Gerechtelijk recht",
    "Gewone mede-eigendom",
    "Grossen",
    "Grosses",
    "Handelszaak",
    "Huisvesting",
    "Huwelijksvermogensrecht",
    "Hypothecair krediet",
    "IPR",
    "IPR en Europees recht",
    "IVZW",
    "Impôts sur les revenus",
    "Inadéquation et insalubrité habitations",
    "Inkomstenbelasting",
    "Inoccupation habitations/immeubles et sites d'activité économique",
    "Insaisissabilité du logement familial",
    "Insolventie-verordening",
    "Inventaire",
    "Kapitaalwijzigingen en uitgifte van effecten",
    "L'ordre",
    "La liquidation-partage judiciaire",
    "La saisie immobilière conservatoire",
    "La tierce décision obligatoire",
    "La vente sur saisie-exécution immobilière",
    "Lastgeving (Volmacht)",
    "Leegstand woningen/gebouwen en bedrijfsruimten",
    "Lening en kredietopening",
    "Lieu et date",
    "Logement",
    "Majeurs incapables",
    "Mandat (procuration)",
    "Marktpraktijken en consumentenbescherming",
    "Meerderjarige onbekwamen",
    "Mentions",
    "Milieu / Bodem",
    "Natuurbehoud",
    "Niet-uitgebate bedrijfsruimten",
    "Notarieel recht",
    "Notarieel recht | Andere formules | Diverse formules",
    "Onbeslagbaarheid gezinswoning",
    "Ondernemings- en vennootschapsrecht",
    "Ondernemingsrecht",
    "Ongeschiktheid en onbewoonbaarheid woningen",
    "Onroerend erfgoed",
    "Ontbinding en vereffening",
    "Onteigening",
    "Oprichting van vennootschap",
    "Overgangsbepalingen",
    "Panneaux solaires",
    "Patrimoine immobilier",
    "Personen-, Familie- en Familiaal vermogensrecht",
    "Personnes morales de droit public",
    "Plaats en datum",
    "Politique intégrée de l'eau - Paragraphe relatif à l'eau",
    "Pratiques du marché et protection du consommateur",
    "Publiciteit",
    "Publicité",
    "Publiekrechtelijke rechtspersonen",
    "Recht op geschriften",
    "Recht van gebruik en bewoning",
    "Recht van opstal",
    "Registratierechten",
    "Rome I-verordening",
    "Rome III-verordening",
    "Routes communales",
    "Ruimtelijke ordening",
    "Ruimtelijke ordening en stedenbouw",
    "Règlement Bruxelles I",
    "Règlement Bruxelles IIbis",
    "Règlement Bruxelles Ibis",
    "Règlement Injonction de payer",
    "Règlement Insolvabilité",
    "Règlement Obligation alimentaire",
    "Règlement Rome I",
    "Règlement Rome III",
    "Règlement Successions",
    "Règlement Titre exécutoire européen",
    "Règlement collectif de dettes",
    "Région de Bruxelles-Capitale",
    "Région flamande",
    "Région wallonne",
    "Saisie-arrêt",
    "Samenwoning",
    "Schenking",
    "Servitudes",
    "Sites d'activité inexploités",
    "Slotverklaringen",
    "Sociétés",
    "Stations-services",
    "Statut administratif",
    "Statutaire clausules",
    "Statuten van mede eigendom",
    "Stichtingen",
    "Structuurwijzigingen",
    "Successierechten",
    "TVA",
    "Tankstations",
    "Traité de Washington",
    "Transaction",
    "Usufruit",
    "VZW",
    "Vastgoedrecht",
    "Vennootschappen",
    "Vente de gré à gré",
    "Vente publique volontaire",
    "Verdrag van Washington",
    "Verenigingen en stichtingen",
    "Verkoop uit de hand",
    "Verschijningsformules",
    "Verwaarlozing woningen/gebouwen en bedrijfsruimten",
    "Vlaams Gewest",
    "Vlaanderen",
    "Voorkooprecht",
    "Voorkooprechten",
    "Vrijwillige openbare verkoop",
    "Vruchtgebruik",
    "Waals Gewest",
    "Waarmerking handtekeningen",
    "Wallonie",
    "Wallonië",
    "Waterparagraaf - Integraal waterbeleid",
    "Wetboek Economisch Recht",
    "Wetboek van internationaal privaatrecht",
    "Zonnepanelen",
    "Électricité",
    "Énergie",
    "Énergie / Certification PEB"
]

const deedTypes = [
    "Regelingsakte(in onverdeeldheid blijven)",
    "Regelingsakte",
    "Schenking en punctuele erfovereenkomst",
    "Schenking en globale erfovereenkomst",
    "Schenking",
    "Herroeping van schenking",
    "Regelingsakte",
    "Familierechtelijke overeenkomst",
    "Schenking en punctuele erfovereenkomst",
    "Schenking en globale erfovereenkomst",
    "Schenking",
    "Herroeping van schenking",
    "Verkoop uit de hand",
    "Loi Sur Les Règlements(Indivision) Restent",
    "Loi Sur Les Règlements",
    "Don Et Accord Ponctuel À La Succession",
    "Don Et Accord Global À La Succession",
    "Don",
    "La Révocation Du Don",
    "Loi Sur Les Règlements",
    "Accord De Droit De La Famille",
    "Don Et Accord Ponctuel À La Succession",
    "Don Et Accord Global À La Succession",
    "Don",
    "La Révocation Du Don",
    "Les Ventes De La Main",
]

const deedGroups = [
    'Familie',
    'Famille',
    'Immo',
    'Immobilier',
    'Ondernemingen',
    'Entreprises'
]


const deedCategories = [
    "Echtscheiding door onderlinge toestemming",
    "Echtscheiding door onderlinge toestemming",
    "Schenking",
    "Schenking",
    "Schenking",
    "Schenking",
    "Echtscheiding door onderlinge toestemming",
    "Echtscheiding door onderlinge toestemming",
    "Schenking",
    "Schenking",
    "Schenking",
    "Schenking",
    "Verkoop uit de hand",
    "Divorce par consentement mutuel",
    "Divorce par consentement mutuel",
    "Donation",
    "Donation",
    "Donation",
    "Donation",
    "Divorce par consentement mutuel",
    "Divorce par consentement mutuel",
    "Donation",
    "Donation",
    "Donation",
    "Donation",
    "Vente de gré à gré",
    "Oprichting van vennootschap",
    "Création d'entreprise",
    "Statuten van mede eigendom",
    "Statuts de copropriété",
]

const deedTransactionTypes = [
    'Onroerend met overdracht van rechten',
    'Niet onroerende goederen',
    'Propriété Avec Transfert Des Droits',
    'Pas Immobilier',
]

const customOptions = []

const clauseClassificationLabelsDutch = [
    "Aanvaarding",
    "Aanwijzing van nieuwe begunstiging",
    "Administratieve Toestand - Stedenbouwkundige Voorschriften",
    "Afstand van de procedure",
    "Afstand",
    "Akte op afstand",
    "aktedatum - instrumenterende(en eventueel tussenkomende) notaris",
    "Alarminstallatie - Rookmelders",
    "Anticipatieve Inbreng",
    "Archeologisch patrimonium",
    "Authentisering",
    "Basisakte",
    "Beding Van Aanwas",
    "Beding van onverdeeldheid",
    "Beeindiging beding van aanwas",
    "Bekrachtigingsakte",
    "Bekwaamheid",
    "Belasting op toegevoegde waarde",
    "Belastingen En Taksen",
    "Belastingen",
    "Bemiddelingsbeding",
    "Bepalingen omtrent gemeenschappelijke (huis)dieren",
    "Beschrijving van het goed",
    "Bevoegde rechtbank",
    "Bijzondere Voorwaarden",
    "Bodemdecreet - Bodemtoestand",
    "Boedelbeschrijving",
    "Bosdecreet",
    "Brusselse huisvestingscode",
    "Brusselse wooncode",
    "Burenhinder",
    "Burgerlijke Staat - Bevestiging Van Identiteit",
    "Conventioneel voorkeur - of voorkooprecht",
    "Conventionele terugkeer",
    "Dading",
    "Deelbaarheid",
    "Definitief karakter van de regelingsakte ",
    "Derdenbeding",
    "Dienst voor alimentatievorderingen",
    "Diverse Verklaringen",
    "Draagwijdte en de uitwerking",
    "Draagwijdte Van De Authentieke Akte",
    "Eigendom - Gebruik - Genot",
    "Eigendomsvoorbehoud",
    "Elektrische Installaties",
    "Energieprestatiecertificaat",
    "Erfdienstbaarheden",
    "Erfgoed - Onteigening - Diverse wetgeving",
    "Erfovereenkomst",
    "Erfrechten en overlevingsrechten",
    "Fidei commis de residuo",
    "Financiele vergoeding",
    "Fiscale verklaringen",
    "Fiscale volmacht",
    "Fiscale woonplaats",
    "gas - en stookolietank",
    "GDPR",
    "Gemeenschappelijke Lasten - Mede - Eigendom",
    "Gesplitste aankoop",
    "Groene Stroomcertificaten - Zonnepanelen",
    "Hernemingen - vergoedingen",
    "Herroeping",
    "Herziening regeling",
    "Huurovereenkomsten",
    "Huwelijksvoordelen",
    "Hypothecaire formaliteiten",
    "Hypothecaire schuld",
    "Hypothecaire toestand",
    "Hypothecaire Volmacht",
    "Inbreng - inkorting - reserve",
    "Indexering onderhoudsgeld",
    "Inneming - mandeligheid - onteigening",
    "Inventaris",
    "Kadastraal Inkomen",
    "KLIM",
    "Kosten",
    "kwijting",
    "Last",
    "Lichamelijke roerende goederen",
    "Loonbeslag = loonmachtiging",
    "Mede - eigendom - erfdienstbaarheden - bijzondere voorwaarden",
    "Meeneembaarheid",
    "Meerderjarige kinderen",
    "Meerwaardebelasting",
    "Mijngebied",
    "Moratoire interesten = nalatigheidsinteresten",
    "Muurgemeenheden",
    "Gebruik van de naam",
    "Natuurdecreet",
    "Natuurlijk Patrimonium",
    "Nietigheid",
    "Nutsvoorzieningen",
    "Ombudsman",
    "Ondeelbaarheid",
    "ongeschiktheid - onbewoonbewaarheid - verwaarlozing - leegstand",
    "Onlichamelijke roerende goederen",
    "Onroerend Erfgoed",
    "Ontbindende voorwaarde",
    "Onteigening - diverse wetgeving",
    "Onteigening - Monumenten / Sites - Rooilijn.",
    "Onteigening - Rooilijn",
    "Ontslag Ambtshalve Inschrijving",
    "Ontvangstmachtiging",
    "Onverdeeldheid van onroerende goederen",
    "Onverdeeldheid",
    "Onvervreemdbaarheid",
    "Oorsprong van de gelden",
    "Oorsprong van eigendom",
    "Opleg",
    "Oplevering",
    "Oppervlakte",
    "Opschortende voorwaarde",
    "Overeenkomst omtrent voorgaande betalingen",
    "Pandregister",
    "Pandwet",
    "Partijen",
    "Personenbelasting",
    "Persoonlijke verschijning",
    "Plaatsbeschrijving en borgstelling",
    "Planbatenheffing - Planschadevergoeding",
    "Planbatenheffing",
    "Postinterventiedossier",
    "Premies",
    "Prijs",
    "Prijsbewimpeling",
    "Pro Fisco Verklaringen",
    "Publiciteitspanelen",
    "Recht Op Geschriften",
    "Recht van natrekking",
    "Recht van wederinkoop",
    "Regeling met betrekking tot het onroerend goed",
    "Regeling ten aanzien van de kinderen",
    "Registratiebelasting",
    "Roerende goederen",
    "roerende zekerheden",
    "Ruilverkaveling - onteigening",
    "Ruilverkaveling",
    "Schenking in volle eigendom",
    "Schenking tussen echtgenoten",
    "Schenkingen - erfenissen - legaten",
    "Schenkingen tussen echtgenoten",
    "Schulden",
    "Schuldsaldoverzekeringen",
    "Staat - oppervlakte - erfdienstbaarheden",
    "Stookolietank",
    "Subrogatie",
    "Taal",
    "Tegenstrijdige Belangen Of Onevenwichtige Bedingen",
    "Tegenwerpelijkheid",
    "Teruggave",
    "Tienjarige Aansprakelijkheid",
    "Tijdelijke en mobiele bouwplaatsen",
    "Toebedeling van onroerend goederen",
    "Toebedeling van roerende goederen",
    "Toekomstige goederen en schulden",
    "Toelichting Van De Akte",
    "Tussenkomst",
    "Uitgifte",
    "Uitkering tussen echtgenoten",
    "Uitsluitingsclausule(verbod van inbreng)",
    "Uitvoerbare kracht",
    "Uitwerking van de overeenkomsten",
    "Veranderlijkheid van overeenkomsten",
    "Verblijfplaats tijdens de procedure",
    "Verbod tot vervreemding",
    "Verbod van vervreemding en hypotheekname",
    "Verborgen - en zichtbare gebreken",
    "Verdeelrecht",
    "verdeling - verkaveling",
    "Vereffening en verdeling",
    "Vereffening/Verdeling van alle rekening",
    "Vergeten of verzwegen vermogensbestanddelen",
    "Vergoedingsrekening",
    "Verkavelingsvergunning",
    "Verklaring van niet - beslagbaarheid",
    "Verklaring voor orde",
    "Verkoop van onroerende goederen",
    "Verkoop",
    "Verlaagd Tarief - Registratiebelasting",
    "Verwarmingsaudit",
    "verwijzing naar eerdere akten",
    "Verzaking aan nietigheid",
    "Verzekeringen",
    "Vierhoekenbeding",
    "Vlaamse Wooncode",
    "Volmacht",
    "Voorafgaande verklaringen",
    "Voorbehoud vruchtgebruik",
    "Voorkeurrecht",
    "Voorkooprechten",
    "Voorlopige binding van de overeenkomsten",
    "Voorwaarden",
    "Voorwaarden, lasten en modaliteiten",
    "Voorwerp van de schenking",
    "Vrijwaring",
    "Vruchtgebruik",
    "Waalse code voor duurzaam wonen",
    "Waardering van het geschonkene",
    "Waarvan Akte",
    "waterparagraaf - integraal waterbeleid",
    "Wederbelegging",
    "Wederzijdse toestemming",
    "Wensen van de schenker(s)",
    "Wettelijke terugkeer",
    "Wijziging van de overeenkomst",
    "Witwaswetgeving",
    "Woningbouwwet - Wet Breyne",
    "woonstkeuze, keuze woonplaats",
    "Zaakvervanging",
    "zonnepanelen",
    "Zorgclausule",
]

const clauseClassificationLabelsFrench = [
    "Abandon de procedure",
    "Acceptation",
    "Acte à distance",
    "acte de base",
    "Anti - blanchiment",
    "Application provisioire des conventions",
    "Assurances",
    "Assurances-vie/décès",
    "Attribution",
    "Audit de chauffage",
    "Authentification",
    "Avantages matrimoniaux",
    "Biens et dettes futures",
    "Biens meubles corporels",
    "Biens meubles incorporels",
    "Biens mobiliers",
    "Capacité",
    "Caractère définitif du règlement transactionnel",
    "Certficat d'identité et état civil",
    "certificat performence energetique batiments",
    "Certificats verts - Panneaux photovoltaiques",
    "Cession de salaire",
    "Chantiers temporaires ou mobiles",
    "Charge",
    "Charges communes - Copropriété",
    "Citerne à gaz et à mazout",
    "Citerne à mazout",
    "Clause d'accroissement",
    "Clause de soins",
    "Clause d'exclusion (interdiction de saisie)",
    "clause d'inaliénabilité",
    "Code Bruxellois du logement",
    "Code Du Logement Bruxellois",
    "Code flamand du logement",
    "Code Wallon de l'Habitation durable",
    "Comparution personelle",
    "Comptes entre époux",
    "Condition résolutiore",
    "Condition suspensive",
    "Conditions du reglement transactionnel",
    "Conditions spéciales",
    "Conditions",
    "Conditions, charges et modalités",
    "Consentement mutuel",
    "Contenance",
    "Contrats de raccordement",
    "Contribution - Réduction - Réserve",
    "Convention d'indivision",
    "Date de l'acte - Notaire instrumentant (et intervenant)",
    "Décharge",
    "Déclaration d'apport anticipé",
    "Déclaration d'insaisissabilité",
    "Déclarations diverses",
    "Déclarations fiscales",
    "Décret forestier",
    "Description du bien",
    "Description du lieu et cautionnement",
    "Détecteurs d'incendie",
    "Dettes",
    "Dispense d'inscription d'office",
    "Division et lotissement",
    "Domicile fiscale",
    "dommages et bénéfices résultant de la planification spatiale",
    "Donation en pleine propriété",
    "Dont acte",
    "Dossier d'intervention ultérieure",
    "droit d'accession",
    "Droit de préemption conventionel",
    "Droit de préférence",
    "Droit de rachat",
    "Droit d'écriture",
    "Droits de préemption",
    "Droits de survie",
    "Droits d'enregistrement",
    "Élection de domicile",
    "Emprise - Mitoyenneté - Expropriation",
    "Enfants majeurs",
    "Etat du bien - Superficie - Servitudes",
    "Expédition",
    "Explication de l'acte",
    "Expose préalable - inventaire - composition des patrimoines",
    "Expropriation - Alignement",
    "Expropriation - législations diverses",
    "Expropriation - Monuments / Sites - Alignement.",
    "Fidei commis de residuo",
    "Force executoire de l'acte notaire",
    "Frais",
    "Gestion et assainissement des sols",
    "Impôts des personnes psychiques",
    "Impôts et taxes",
    "Inadéquation et insalubrité habitations",
    "Indemnisation",
    "Indivisibilité",
    "Indivision",
    "Installations électrique",
    "Insuffisance",
    "interdiction d'aliénation",
    "Intérêts contradictoires où engagements disproportionnés",
    "Interets de retard",
    "Intervention",
    "Inventaire",
    "L'achat démembré",
    "Les dispositions relatives aux animaux communs",
    "Les dispositions relatives aux enfants",
    "Livraison",
    "l'objet de la donnation",
    "Loi Breyne",
    "Loi sur des gages",
    "Mandat fiscale",
    "Mandat hypothécaire",
    "Mandat",
    "Médiation",
    "Mitoyennetés - servitudes - conditions spéciales",
    "Mitoyennetés",
    "Mutabilité des conventions",
    "Utilisation du nom",
    "Nullité",
    "Observatoire foncier Wallon",
    "Occupation - Propriété - Jouissance",
    "Ombudsman",
    "Opposabilité - Abandonnement",
    "Opposabilité",
    "Origine de proprieté",
    "Origine des fonds",
    "Pacte successoral",
    "Panneaux photovoltaiques",
    "Panneaux publicitaires",
    "Parties",
    "Patrimoine - Expropriation - Législations diverses",
    "Patrimoine archéologique",
    "Patrimoine Naturel",
    "Pension alimentaire entre époux",
    "Permis de lotir",
    "Point De Contact Fédéral Informations Câbles Et Conduites(Cicc)",
    "Portée de l'acte authentique",
    "Primes",
    "Prise d'effets des conventions",
    "Prix",
    "Pro Fisco",
    "Protection de la nature / natura 2000",
    "Protection du patrimoine",
    "Référence aux actes an antérieurs",
    "Registre des gages",
    "Reglement transactionnel",
    "réinvestissement",
    "Remembrement - Expropriation",
    "Remembrement urbain",
    "Renoncement",
    "Renonciation à nullité",
    "Représentation d'une des parties",
    "Reprises",
    "réserve de propriété",
    "Réserve usufruit",
    "Résidence des époux",
    "Responsabilité décennale",
    "Retour conventionnel",
    "Retour légal",
    "Revenu cadastral",
    "Revenus et dettes des epoux",
    "Révision amiable ou judiciaire",
    "Révocation",
    "RGPD",
    "Service des créances alimentaires",
    "Servitudes",
    "Situation hypothécaire",
    "Solidarité",
    "Statut adminitratif - Aménagement du territoire et urbanisme",
    "Subrogation - Substitution",
    "Subrogation",
    "Successions - donations - legs",
    "Sûreté réelle",
    "Taux réduit",
    "Taxation des plus - values",
    "Taxe sur la valeur ajoutée",
    "taxe sur les bénéfices résultant de la planification",
    "Taxes",
    "Transcription du divorce",
    "Tribunal compétent",
    "Troubles de voisinage",
    "Usufruit",
    "Valoralisation de la donation",
    "Vente",
    "Vices cachés et visibles",
    "Volontes des donateur(s)",
    "Zone miniers",
    "Zones à risque - Zone inondable",
]

const formatAutocompleteUnified = option => {
    return capitalizeTitle(option.trim())
}

const clauseAutocompleteOptions = [
    ...deedTypes,
    ...deedGroups,
    ...deedCategories,
    ...deedTransactionTypes,
    ...customOptions,
    ...clauseClassificationLabelsDutch,
    ...clauseClassificationLabelsFrench,
].map(formatAutocompleteUnified)

const modelAutocompleteOptions = [
    ...modelNames,
].map(formatAutocompleteUnified)

export {
    clauseAutocompleteOptions,
    modelAutocompleteOptions,
}